var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalCropLineWaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.5,
    height: 11,
    viewBox: "0 0 48 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.117101 1.17174L8.5917e-07 1.17223L9.61617e-07 0.000382995L48 0.000387192L48 1.17566C45.8268 1.23474 43.7136 1.91638 41.9133 3.14246L35.4711 7.53015C28.6785 12.1566 19.7471 12.1566 12.9543 7.53014L6.5125 3.14245C4.6268 1.85827 2.3983 1.17174 0.117101 1.17174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalCropLineWaveIcon);
export default __webpack_public_path__ + "static/media/terminalCropLineWaveIcon.3503dc2535fe90192632b2d41af99a1c.svg";
export { ForwardRef as ReactComponent };